import { ActionError } from 'Interfaces/ActionCreators';
import { call, cancelled, put, takeLeading } from 'redux-saga/effects';
import SignatureRequestApiService from 'Services/Api/SignatureRequest';

import { deleteSignatureRequests } from './actionCreators';

function* handleSignatureRequestsDelete({
  payload,
  meta,
}: ReturnType<typeof deleteSignatureRequests.request>) {
  try {
    yield call(
      SignatureRequestApiService.deleteSignatureRequests,
      payload.signatureRequestIds,
    );
    yield put(deleteSignatureRequests.success(undefined, meta));
  } catch (error) {
    yield put(deleteSignatureRequests.failure(error as ActionError, meta));
  } finally {
    if (yield cancelled()) {
      yield put(deleteSignatureRequests.cancel(undefined, meta));
    }
  }
}

export default [
  takeLeading(deleteSignatureRequests.request, handleSignatureRequestsDelete),
];
